import React from 'react';
import { observer, inject } from 'mobx-react';
import { Panel, Row, Col,Button } from 'react-bootstrap';
import AnnouncementList from './AnnouncementList';
import AddAnnouncement from './AddAnnouncement';


@inject('announcementStore')
@observer
export default class Announcements extends React.Component {

    render() {
        return (<Panel>
            <Panel.Heading>
                   <Row>
                       <Col lg={10} > <h5>Announcements</h5> </Col>
                       <Col lg={2} ><Button bsStyle="primary" onClick={()=>{this.props.announcementStore.ToggleAddAnnouncementModal();}} >Add Announcement</Button></Col>
                   </Row>
            </Panel.Heading>
            <Panel.Body>
                <AnnouncementList />
                <AddAnnouncement/>
            </Panel.Body>
        </Panel>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Announcements/index.js